import { useState, useRef } from "react";
import "./ProfileImage.css";
import me0 from "../assets/me0.png";

const EFFECTS = ["lift", "rotate-scale", "filter", "tilt"];

function pickEffect(previous) {
  const pool = EFFECTS.filter((e) => e !== previous);
  return pool[Math.floor(Math.random() * pool.length)];
}

export default function ProfileImage({ alt = "Lorenzo Amabili", width = 220 }) {
  const [effect, setEffect] = useState(null);
  const lastEffect = useRef(null);

  function handleMouseEnter() {
    const next = pickEffect(lastEffect.current);
    lastEffect.current = next;
    setEffect(next);
  }

  function handleMouseLeave() {
    setEffect(null);
  }

  return (
    <img
      src={me0}
      alt={alt}
      width={width}
      className={["profile-image", effect ? `profile-image--${effect}` : ""]
        .filter(Boolean)
        .join(" ")}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
}
